// @flow

import MuiDatePicker from './MuiDatePicker'

export default MuiDatePicker
